<template>
  <div class="box box__selected">
    <div>
      <div class="box-title box-title__theme">
        {{ getElementLabel() }}
      </div>
      <a @click="sidebarChangePanel('style')" class="box-back">
        <i class="fa fa-arrow-left"></i> {{$t('general.actions.back')}}
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  computed: mapGetters({
    element: 'sidebarCurrentElement',
  }),
  methods: {
    getElementLabel() {
      return this.element ? this.element.getAttribute('klickbox-edit-label') : '';
    },
    ...mapActions([
      'sidebarChangePanel',
    ]),
  },
};
</script>



/** WEBPACK FOOTER **
 ** Header.vue?651692df
 **/